import { defineMessages, useIntl } from 'react-intl'
import { useSelector } from 'react-redux'

// Components
import { Text, Format } from '../../..'

// Selectors
import { selectAVMAppreciationPercent } from '../../../../store/selectors/home/avm'

interface AppreciationSentenceProps {
  withCurrentHomeData: boolean
  className?: string
}

export const MSG = defineMessages({
  appreciatedOverTenPercent: {
    id: 'Homeowner.estimatedValue.appreciatedOverTenPercent',
    defaultMessage: "That's up {percent} from when you bought it. Nice!",
  },
  appreciatedOverZeroPercent: {
    id: 'Homeowner.estimatedValue.appreciatedOverZeroPercent',
    defaultMessage: "That's up {percent} from when you bought it.",
  },
  depreciatedOverZeroPercent: {
    id: 'Homeowner.estimatedValue.depreciatedOverZeroPercent',
    defaultMessage: 'Down {percent} from when you bought it.',
  },
})

export const AppreciationSentence = ({
  withCurrentHomeData,
  className,
}: AppreciationSentenceProps) => {
  const intl = useIntl()
  const appreciationPercent = useSelector(selectAVMAppreciationPercent)
  if (!appreciationPercent || !withCurrentHomeData) {
    return null
  }

  const getMessage = (appreciationPercent: number) => {
    const percent = Format.percentage(Math.abs(appreciationPercent))

    if (appreciationPercent > 10) {
      return intl.formatMessage(MSG.appreciatedOverTenPercent, { percent })
    }

    if (appreciationPercent > 0) {
      return intl.formatMessage(MSG.appreciatedOverZeroPercent, { percent })
    }

    if (appreciationPercent < 0) {
      return intl.formatMessage(MSG.depreciatedOverZeroPercent, { percent })
    }

    return null
  }

  const message = getMessage(appreciationPercent)

  if (!message) {
    return null
  }

  return (
    <Text
      data-qa='qa-appreciation-sentence'
      variant='neutralCool'
      variantCount='700'
      align='center'
      paragraph
      className={className}
    >
      {message}
    </Text>
  )
}
